export { multisitePlugin } from 'src/lib/extract-path/plugins/multisite';
export { pdpSkuPlugin } from 'src/lib/extract-path/plugins/pdp-sku';
export { personalizePlugin } from 'src/lib/extract-path/plugins/personalize';
export { storeIdPlugin } from 'src/lib/extract-path/plugins/store-id';
